module.exports = __webpack_public_path__ + "img/recommed-img1.8d709de1.jpg";